<template>
<div class="row no-gutters body">
    <div class="col-lg-3 middle-background" v-if="individualPage"></div>
    <div class="col-12 pb-5 mb-4" :class="{'col-lg-9':individualPage}" v-if="pageloader">
        <img src="../assets/pageloader.svg" class="pageloader" alt="loadinganimation">
        </div>
    <div class="col-12 pl-0 pr-0 main-card" :class="{'individualpage' :individualPage, 'col-lg-6':(individualPage)}" v-else>
        <div class=" card card1 ml-3 mr-3 mt-lg-2 jobSec" v-if="reqNotFound">
            <div class="d-flex flex-column p-5 mx-auto">
                <img src="../assets/no_video.svg" class="img-fluid no-video pl-5 pr-5 pb-4 mx-auto" alt="novideo">
                <span class="proximanova-thin fontsize24 black60">You don't have any access to see the request information</span>
            </div>
        </div>
        <div class="d-flex backgroundcolor2 borderadius12 p-1 pr-3 mb-2 pointer ml-1" style="width:220px" v-if="individualPage && !reqNotFound" @click="NavToRequests">
            <img src="../assets/JobBack.svg" alt="back">
            <span class="fontsize14 stylebold black ml-2">Resume Request Details</span>
        </div>
        <div class="shadow card borderradius10  pb-5 "  v-if="!reqNotFound">
                <div class="p-2 pl-lg-3 pr-lg-3 mb-1 d-flex">   
                    <div class="col-md-1 p-lg-2 pl-0 pr-0 borderradius10 mr-2 mt-1 text-center" v-if="reqDetails.roleName=='Recruiter'">
                        <img v-if="reqDetails.empProfileLink" :src="reqDetails.empProfileLink" class="border loadingBgImg jobImg rounded-circle" alt="companylogo">
                        <img v-else src="../assets/Profile_placehlder.svg" class="jobImg rounded-circle" alt="companylogo">
                    </div>
                    <div class="col-md-1 p-lg-2 pl-0 pr-0 borderradius10 mr-2 mt-1 text-center" v-else>
                        <img v-if="reqDetails.companyLogo" :src="reqDetails.companyLogo" class="border loadingBgImg jobImg rounded-circle" alt="companylogo">
                        <img v-else src="../assets/Profile_placehlder.svg" class="jobImg rounded-circle" alt="companylogo">
                    </div>
                    <div class="col-10 pl-0 pl-md-2 pt-2">
                        <div class="d-flex flex-column" v-if="reqDetails.roleName=='Recruiter'">
                            <span class="fontsize16 black proximanova stylebold nameBlock mt-md-1">{{reqDetails.fullName}}</span>
                            <span class="fontsize14 black proximanova nameBlock">{{reqDetails.companyName}} User</span>
                        </div>
                        <div class="d-flex flex-column" v-else>
                            <span class="fontsize16 black proximanova stylebold nameBlock mt-1">{{reqDetails.companyName}}</span>
                        </div>
                        <span class="black30 proximanova fontsize12 text-nowrap" v-if="reqDetails.creationDate">{{ reqDetails.creationDate | moment("from", "now", true)}} Ago</span>
                    </div>
                </div>
                <div class="sign-in-navheight col-11 p-2 pt-lg-3 pb-lg-3 p-md-4 mx-auto borderradius10 mt-2">
                    <div class="col-12 d-flex flex-column p-3 pt-lg-2 pb-lg-2 p-md-4 borderradius10 backgroundcolorwhite">
                        <span class="fontsize18 black proximanova stylebold nameBlock">{{reqDetails.jobTitle}}</span>
                        <span class="fontsize14 black proximanova nameBlock">at Team <span class="blue proximanova-semibold pointer" @click="navToCompany">{{reqDetails.companyName}}</span></span>
                        <span class="d-flex mt-1">
                            <img src="../assets/JobViewLocation.svg" class="iconImg" alt="location">
                            <span class="fontsizemd black proximanova ml-2">{{reqDetails.cityName}}, {{reqDetails.countryName}}.</span>
                        </span>
                        <div class="col-12 pl-0 pr-0">
                            <div class="d-flex flex-column pb-1">
                                <div class="row no-gutters ml-0">
                                    <div v-if="reqDetails.jobSkillList && reqDetails.jobSkillList.length > 0" class="d-flex flex-wrap mb-2 col" >
                                        <div v-for="(skill, index) in reqDetails.jobSkillList" :key="index" >
                                            <div class="pl-3 pr-3 p-1 mr-3 text-nowrap black80 fontsize12 backgroundcolor2 stylebold borderradius10 proximanova d-flex mt-1">
                                                {{skill}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>       
                        </div>
                        <span class="fontsize14 black proximanova-semibold nameBlock blue pointer mt-2" @click="navtoFullJobDetails">View full Job Information</span>      
                    </div>
                    <div class="col-12 d-flex flex-column mt-2 mt-md-4 p-3 pt-lg-2 pb-lg-2 p-md-4 borderradius10 backgroundcolorwhite">
                        <div class="d-flex">   
                            <div class="col-md-1 pl-0 pr-0 borderradius10 mr-2 mt-1 text-center" v-if="reqDetails.roleName=='Recruiter'">
                                <img v-if="reqDetails.empProfileLink" :src="reqDetails.empProfileLink" class="border loadingBgImg jobImg rounded-circle" alt="companylogo">
                                <img v-else src="../assets/Profile_placehlder.svg" class="jobImg rounded-circle" alt="companylogo">
                            </div>
                            <div class="col-md-1 pl-0 pr-0 borderradius10 mr-2 mt-1 text-center" v-else>
                                <img v-if="reqDetails.companyLogo" :src="reqDetails.companyLogo" class="border loadingBgImg jobImg rounded-circle" alt="companylogo">
                                <img v-else src="../assets/Profile_placehlder.svg" class="jobImg rounded-circle" alt="companylogo">
                            </div>
                            <div class="col-10 pl-0 my-auto">
                                <div class="d-flex flex-column" v-if="reqDetails.roleName=='Recruiter'">
                                    <span class="fontsize16 black60 proximanova stylebold nameBlock mt-1">{{reqDetails.fullName}}</span>
                                </div>
                                <div class="d-flex flex-column" v-else>
                                    <span class="fontsize16 black60 proximanova stylebold nameBlock mt-1">{{reqDetails.companyName}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex flex-column mt-2">
                            <!-- <quill-editor v-model="reqDetails.jobDesc" :options="editorOption" class="quill1" disabled></quill-editor> -->
                            <span v-if="reqDetails.message" class="fontsize14 black proximanova">{{reqDetails.message}}</span>
                            <span v-else class="fontsize14 black60 proximanova">No Message...</span>
                        </div>
                    </div>
                    <div class="col-12 d-flex flex-column mt-2 mt-md-4 p-3 p-md-4 borderradius10 backgroundcolorwhite text-center">
                        <span class="fontsize18 black proximanova stylebold nameBlock">Take an action on this job invite</span>
                        <span class="fontsize14 black60 proximanova nameBlock">Employer will be notified</span>
                        <div class="col-8 mx-auto mt-3 d-md-flex justify-content-around" v-if="reqDetails.status=='Requested'">
                            <div class="col-6 mt-2" v-if="acceptBtnClicked"><img src="../assets/uploadvideo.svg" width="28px" alt="uploading" class="img-fluid ml-2 mr-2"></div>
                            <button v-else :disabled="acceptBtnClicked||rejectBtnClicked" class="col-md-6 proximanova-semibold pl-3 pr-3 p-1 mt-2 border-0 backgroundcolorblack white borderradius20" @click="acceptDeclineInvitation('Accepted')">Accept Invite</button>
                            <div class="col-6 mt-2" v-if="rejectBtnClicked"><img src="../assets/uploadvideo.svg" width="28px" alt="uploading" class="img-fluid ml-2 mr-2"></div>
                            <button v-else :disabled="acceptBtnClicked||rejectBtnClicked" class="col-md-6 proximanova-semibold ml-1 pl-3 pr-3 p-1 mt-2 borderblack backgroundnone black borderradius20" @click="acceptDeclineInvitation('Declined')">Decline Invite</button>
                        </div>
                        <div class="col-8 mx-auto mt-3 d-md-flex justify-content-around" v-else>
                            <span class="proximanova-semibold pl-3 pr-3 p-1 mt-2 border-0 backgroundcolor6 green borderradius20" v-if="reqDetails.status=='Accepted'">Accepted</span>
                            <span class="proximanova-semibold pl-3 pr-3 p-1 mt-2 border-0 backgroundcolor7 red borderradius20" v-if="reqDetails.status=='Declined'">Declined</span>
                        </div>
                    </div>
                </div>   
            </div>
        </div>
        <div class="col middle-background" v-if="individualPage && !pageloader ">
            <div class="row no-gutters">
                <br />
            </div>
            <div class="row row no-gutters">
                <br />
            </div>
            <pendingActivities />
        </div>
        <APIerrorModal v-if="displayAPIerrorModal" @closeAPIerrorModal="closeAPIerrorModal"></APIerrorModal> 
</div>
</template>
<script>
import { bus } from "../main";
import httpuserprofile from "@/js/http-userprofile.js";
import httpjob from "@/js/http-postjob.js";
import APIerrorModal from './APIerrorpopup.vue'
import pendingActivities from "./PendingActivities.vue";
import router from '../router.js'
import wndata from '@/js/wn_data.json'
import commonUtils from '@/js/common-utils.js'
import sessionUtils from '@/js/session-util.js'
export default{
    components: {
        APIerrorModal,
        pendingActivities
    },
    data(){
        return{
            reqNotFound : false,
            currentRoute : null,
            pageloader : true,
            individualPage : false,
            currentUserProfileId : null,
            reqId : null,
            reqDetails : null,
            editorOption: {
                theme: 'bubble'
            },
            displayAPIerrorModal : false,
            acceptBtnClicked : false,
            rejectBtnClicked : false
        }
    },
    watch: {
        '$route.params.id': function () {     
            this.individualPage = true
            this.reqNotFound = false
            this.reqDetails = null
            this.reqId = this.$route.params.id
            this.getResumeRequestDetails()
        }
    },
    mounted(){
        window.scrollTo(0, 0)
        let currentRoute = this.$route.name;
        this.currentRoute = currentRoute;
        console.log("route name : ", currentRoute)
        this.currentUserProfileId = sessionUtils.getUserProfileId();
        if(currentRoute === 'selectedresumerequest'){
            this.individualPage = true;
            this.reqId = this.$route.params.id
            this.getResumeRequestDetails()
        }
        if(!this.individualPage && currentRoute !== 'selectedresumerequest') {
            bus.$on("selectrequestedresume", data => {
                console.log("data in videoviews : ", data)
                this.reqId = data;
                this.getResumeRequestDetails()
            })
        }
    },
    beforeDestroy(){
        bus.$off('selectrequestedresume')
    },
    methods:{
        closeAPIerrorModal(){
            this.displayAPIerrorModal = false;
        },
        NavToRequests() {
            // this.$router.go(-1);
            router.push({
                name : 'interestedinyou'
            })
        },
        navToCompany() {
            if(this.reqDetails.companyAliasName){
                this.$router.push({name: 'wncompany', params: { id: this.reqDetails.companyAliasName}});
            }
        },
        navtoFullJobDetails() {
            if(this.reqDetails.jobAliasId){
                this.$router.push({
                name : 'viewjob', params: { id: this.reqDetails.jobAliasId}
                })
            }
        },
        acceptDeclineInvitation(status) {
            var vm = this;
            if(status == 'Accepted'){
                this.acceptBtnClicked = true;
                this.rejectBtnClicked = false
            }else{
                this.acceptBtnClicked = false;
                this.rejectBtnClicked = true
            }
            httpjob.put('postjob/acceptOrDeclineRequest?reqId='+this.reqId+'&email='+sessionUtils.getUserEmail()+'&status='+status)
            .then((response) => {
                console.log("updated request accept : ", response.data)
                if(response.data && response.data.errorCode == 1054){
                    this.reqDetails.status = status;
                    vm.$toast.success(response.data.errorMessage)
                }
                this.acceptBtnClicked = false;
                this.rejectBtnClicked = false;
            }).catch((e) => {
                console.log(e.response)
            })
        },
        //this will invoke after component is mounted to get the job details based on job id
        getResumeRequestDetails(){
            this.pageloader = true;
            httpjob.get('/postjob/getResumeRequestById?reqId='+this.reqId+'&loggedInUerId='+this.currentUserProfileId)
            .then((response) => {
                this.pageloader = false;
                console.log(response)
                if(response.data && response.data.errorCode){
                    this.reqNotFound = true;
                }else{
                    this.reqNotFound = false;
                    this.reqDetails = response.data;
                }
            }).catch((e) => {
                console.log(e.response)
                this.pageloader = false;
            })
        },
    }
}
</script>
<style scoped>
.productvideocard{
	padding-left: 0;
	padding-right: 0;
	border-radius: 10px;
  }
.pausebtn{
  display: none;
}
.productvideocard:hover .pausebtn{
  display: block;
  margin-top: 7.5% !important;
}
.jobSec {
  /* background-color: #e8e9eb; */
  background-color: rgba(161, 166, 179, 0.085);
  border: none;
}
.playpausevideobtn{
    margin-top: 5% !important;
    margin-left: 48% !important;
    cursor: pointer;
  }
  video{
      width: 100%;
  }
  .bottom{
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
}
.activeBtn{
    background-color: rgba(16,163,129,0.2);
}
.backgroundcolor2 {
    /* width: 80px; */
    padding-left: 20px !important;
}
.quill1{
  width: 100%;
}
.iconImg{
    width: 20px;
    height: 20px;
}
.loadingBgImg{
  background: transparent url('../assets/loading_gif1.gif') center no-repeat;
  background-size: 30px 30px;
}
.individualpage{
    background: #F0F2F5 !important;
}
#followImage{
  width: 30px;
  height: 30px;
  transform: scale(1.2)  !important;
  border: 1px solid #1F1F1F;
}
.white{
    color: white !important;
}
.pageloader {
  width: 10%;
  margin-top: 15%;
  margin-bottom: 5%;
  margin-left: 46%;
}
.selectedloginviewjobstyles{
    width: 5%  !important;
    margin-left: 48%;
}
.button-cancel11 {
  border: 1px solid #1f1f1f;
  background: none !important;
  border-radius: 4px;
  transition : ease-out 0.3s;
  font-size: 14px !important;
	position: relative;
	z-index : 1;
}
.individualpage{
    margin-top: 7%;
    margin-bottom: 5%;
}
.singlejobpage{
    margin-top: 7%;
    margin-bottom: 5%;
    padding-left: 2% !important;
    padding-right: 2% !important;
}
.profhoriz {
  margin-top: .25em;
  margin-bottom: .25em;
  margin-left: 15px;
  margin-right: 15px;
  border-top: 1.5px solid rgba(0,0,0,.1)
}
#introVideo{
    width: 100%;
}
.jobImg{
    width: 40px;
    height: 40px;
}
.followbtn{
  transition : ease-out 0.3s;
  POSITION : relative;
  z-index : 1;
  text-align: right;
  /* right:2%; */
  padding-left : 5px;
  padding-top: 2px;
  padding-right: 5px;
  padding-bottom: 2px;
}
.followbtn::before {
  transition : 0.5s all ease;
  position : absolute;
  top : 0;
  left : 30%;
  right : 10%;
  bottom : 0;
  opacity : 0;
  content : "";
  border-radius:20px;
  background-color :  rgba(31,31,31,.3);
}
.followbtn:hover:before {
  transition : 0.5s all ease;
  left : 0;
  right : 0;
  padding-left:5px;
  opacity : 1;
  z-index : -1;
  border-radius:20px;
}
#playvideobtn {
  /* display: none; */
  margin-left: 45%;
  margin-top: 7% !important;
  cursor: pointer;
}
.action:hover{
    background: rgba(31,31,31,.1);
    border-radius: 5px;
}
.closebtnmouseover {
    border: 1px solid white;
    padding: 2px;
}
.closebtnmouseover:hover {

  background-color: rgba(161, 166, 179,0.1);
  border-radius: 60%;
  border: 1px solid rgba(161, 166, 179,.5);
}
.welcomemenu.vue-popover.dropdown-position-bottom:before{
    display: none;
}
.welcomemenu.dropdown-position-bottom {
  left: unset !important;
  /* right: 0 !important; */
  top: 20px !important;
  width: 220px !important;
  padding: 10px 10px 10px 10px !important;
  transform: translate3d(-82%, 10px, 10px) !important;
}
@media only screen and (max-width: 550px) {
    .individualpage{
        margin-top: 22%;
        margin-bottom: 15%;
    }
    .singlejobpage{
        margin-top: 22% !important;
        margin-bottom: 15%;
    }
    #followImage{
  width: 20px;
  height: 20px;
    }
    .jobImg{
    width: 30px;
    height: 30px;
}
    .nameBlock{
        font-size: 18px !important;
	}
}
@media screen and (max-width: 1020px) and (min-width: 767px) {
  .main-card {
    padding-left: 5% !important;
    padding-right: 5% !important;
  }
}
@media screen and (max-width : 768px) {
  .pageloader {
      width: 10%;
    margin-top: 25% !important;
  }
  .singlejobpage{
        margin-top: 15%;
        margin-bottom: 15%;
    }
    .individualpage{
        padding-left: 5% !important;
    padding-right: 5% !important;
    }
}
</style>